/**
 * Live Modal Component
 */

import React from 'react';
import { Modal } from 'antd';

interface LiveModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const LiveModal: React.FC<LiveModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal
      title="Mark Quote as Live"
      open={open}
      onCancel={onClose}
      onOk={onConfirm}
      okText="Confirm"
      cancelText="Cancel"
      confirmLoading={isLoading}
      width={500}
    >
      <p className="text-gray-600 mb-2">
        Are you sure you want to mark this quote as live?
      </p>
      <p className="text-sm text-gray-500">
        This will activate the quote and make it available for customers.
      </p>
    </Modal>
  );
};

export default LiveModal;
